import { Component, Input, OnInit } from '@angular/core';

import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInput } from '@angular/material/input';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SMSI18NModule } from '../../../../assets/i18n/sms-i18n.module';

@Component({
  selector: 'sms-address-fields',
  imports: [GalaxyFormFieldModule, MatInput, ReactiveFormsModule, TranslateModule, SMSI18NModule],
  templateUrl: './sms-address-fields.component.html',
  styleUrl: './sms-address-fields.component.scss',
})
export class SmsAddressFieldsComponent implements OnInit {
  @Input({ required: true }) parentFormGroup!: FormGroup;

  formGroup = new FormGroup({
    streetAddress1: new FormControl('', Validators.required),
    streetAddress2: new FormControl(''),
    city: new FormControl('', Validators.required),
    state: new FormControl('', Validators.required),
    postalCode: new FormControl('', Validators.required),
  });

  ngOnInit() {
    this.parentFormGroup.addControl('address', this.formGroup);
  }
}
